export default {
  'menu.manufacturer': '厂商仪表盘',
  'menu.manufacturer.openbrowser': 'Open Browser',
  'menu.manufacturer.metaxtv': 'MetaX TV',
  'menu.manufacturer.adsdk': 'Ad SDK',
  'menu.manufacturer.distributionPerf': 'MetaX 平台',
  'menu.manufacturer.distributionThirdParty': '第三方平台',

  'menu.operator': '运营商仪表盘',
  'menu.operator.openbrowser': 'Open Browser',
  'menu.operator.metaxtv': 'MetaX TV',
  'menu.operator.adsdk': 'Ad SDK',
  'menu.operator.distributionPerf': 'MetaX 平台',
  'menu.operator.distributionThirdParty': '第三方平台',

  'menu.cp': '内容商仪表盘',
  'menu.cp.openbrowser': 'Open Browser',
  'menu.cp.metaxtv': 'MetaX TV',
  'menu.cp.adsdk': 'Ad SDK',
  'menu.cp.distributionPerf': 'MetaX 平台',
  'menu.cp.distributionThirdParty': '第三方平台',

  'menu.resellers': '渠道商仪表盘',
  'menu.resellers.openbrowser': 'Open Browser',
  'menu.resellers.metaxtv': 'MetaX TV',
  'menu.resellers.adsdk': 'Ad SDK',
  'menu.resellers.distributionPerf': 'MetaX 平台',
  'menu.resellers.distributionThirdParty': '第三方平台',

  'menu.report': '报表',
  'menu.report.metaxtv': 'MetaX TV',
  'menu.report.openbrowser': 'Open Browser',
  'menu.report.distribution': 'MetaX 平台',
  'menu.report.thirdPartyDistribution': '第三方平台',  
  'menu.report.adsdk': 'Ad SDK报表',

  'menu.setting': '设置',
  
  'menu.access': '访问 & 授权',
  'menu.access.account': '账户设置',
  'menu.access.access': '用户管理',

  'menu.setting.reportApi': '报表API',
  
  'menu.admin': '管理',
  'menu.admin.global': '全局设置',
  'menu.admin.partner-bind': '客户绑定',
  'menu.admin.account': '账户管理',
  'menu.admin.team': '团队管理',
  'menu.admin.company': '公司管理',
  'menu.admin.permissions': '权限管理',
  'menu.admin.role': '角色管理',

  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.login': '登录',
  'menu.update-password': '更新密码',
  'menu.reset-password': '重置密码',
  'menu.forgot-password': '忘记密码',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};
